import { useQueryParams } from './useQuery';

export function getUrlParams(value: string): string {
  const query = useQueryParams();
  const param = query.get(value);
  return param === null ? '' : param;
}
